if (!customElements.get('faq-accordion')) {
  customElements.define(
    'faq-accordion',
    class FaqAccordion extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.faq__trigger');
        this.panel = this.querySelector('.faq__panel');
        this.trigger.addEventListener('click', this.toggle.bind(this));
      }

      toggle() {
        const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
        isOpen ? this.close() : this.open();
      }

      open() {
        this.trigger.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;
        this.panel.style.gridTemplateRows = '0fr';
        requestAnimationFrame(() => {
          this.panel.style.gridTemplateRows = '1fr';
        });
      }

      close() {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.panel.style.gridTemplateRows = '0fr';
      }
    }
  );
}
